module.exports = __webpack_public_path__ + "img/bg_1.06de057e.jpg";